/**
 * Created by mac on 7/8/18
 * @return {boolean}
 */

cleverapps.FBLoginOrInvite = function () {
    if (!connector.social.isConnected() || cleverapps.flags.nologin || !connector.platform.listShareChannels().includes("invite")) {
        return;
    }

    const node = new cc.Node();
    node.setAnchorPoint(0.5, 0.5);

    const removeSelf = node.createListener(() => {
        node.removeFromParent(true);
    });

    const button = new InviteButton({
        onSuccess: removeSelf
    });
    button.setAlignment(button.width / 2, button.height / 2);
    node.setContentSize2(button);
    node.addChild(button);

    const styles = cleverapps.styles.FBLoginOrInvite;
    if (styles.images.avatars) {
        const rightAvatar = new cleverapps.UI.Avatar(bundles.avatars.frames[cleverapps.UI.Avatar.GetAvatarFramesNames()[0]], { frame: bundles.avatar.frames.avatar_frame2 });
        rightAvatar.setScale(styles.images.avatars.scale);
        rightAvatar.setAlignment(styles.images.avatars.right.x, styles.images.avatars.right.y);
        rightAvatar.setRotation(styles.images.avatars.right.rotation);
        button.addChild(rightAvatar);

        const leftAvatar = new cleverapps.UI.Avatar(bundles.avatars.frames[cleverapps.UI.Avatar.GetAvatarFramesNames()[0]], { frame: bundles.avatar.frames.avatar_frame2 });
        leftAvatar.setScale(styles.images.avatars.scale);
        leftAvatar.setAlignment(styles.images.avatars.left.x, styles.images.avatars.left.y);
        leftAvatar.setRotation(styles.images.avatars.left.rotation);
        button.addChild(leftAvatar);
    }

    // eslint-disable-next-line no-restricted-syntax
    const message = cleverapps.UI.generateTTFText(Messages.get("FBLoginOrInvite.invite"), cleverapps.styles.FONTS.FBLOGINORINVITE_TEXT);
    message.setPosition(node.width / 2 + styles.text.offsetX, node.height + styles.text.offsetY);
    message.fitTo(styles.text.width);
    node.addChild(message);

    node.setVisible(false);
    node.runAction(new cc.Sequence(
        new cc.ScaleTo(0, 0),
        new cc.Show(),
        new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut())
    ));

    message.setOpacity(0);
    message.runAction(new cc.Sequence(
        new cc.DelayTime(0.5),
        new cc.FadeIn(0.5)
    ));

    cleverapps.UI.wrap(node);

    return node;
};

cleverapps.styles.FBLoginOrInvite = {
    images: {
        avatars: {
            scale: 0.6,

            left: {
                x: { align: "left", dx: -110 },
                y: { align: "center" },
                rotation: -7
            },

            right: {
                x: { align: "left", dx: -80 },
                y: { align: "center", dy: 5 },
                rotation: 13
            }
        }
    },

    text: {
        offsetX: -40,
        offsetY: 26,
        width: 700
    }
};